<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "SalesSurvey",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  